// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__MzOU0","icon":"styles_icon__5DRGl"};